import React from "react";

const CalendarSVG = ({ width, height, fill, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill={fill}
      {...props}
    >
      <path
        fill={fill}
        d="M7.38 1.44043C7.38 0.888145 6.93228 0.44043 6.38 0.44043C5.82772 0.44043 5.38 0.888145 5.38 1.44043H7.38ZM5.38 4.21043C5.38 4.76271 5.82772 5.21043 6.38 5.21043C6.93228 5.21043 7.38 4.76271 7.38 4.21043H5.38ZM14.84 1.44043C14.84 0.888145 14.3923 0.44043 13.84 0.44043C13.2877 0.44043 12.84 0.888145 12.84 1.44043H14.84ZM12.84 4.21043C12.84 4.76271 13.2877 5.21043 13.84 5.21043C14.3923 5.21043 14.84 4.76271 14.84 4.21043H12.84ZM5.89 3.88043H14.33V1.88043H5.89V3.88043ZM14.33 3.88043C16.4784 3.88043 18.22 5.62204 18.22 7.77043H20.22C20.22 4.51747 17.583 1.88043 14.33 1.88043V3.88043ZM18.22 7.77043V13.6704H20.22V7.77043H18.22ZM18.22 13.6704C18.22 15.8188 16.4784 17.5604 14.33 17.5604V19.5604C17.583 19.5604 20.22 16.9234 20.22 13.6704H18.22ZM14.33 17.5604H5.89V19.5604H14.33V17.5604ZM5.89 17.5604C3.74161 17.5604 2 15.8188 2 13.6704H0C0 16.9234 2.63704 19.5604 5.89 19.5604V17.5604ZM2 13.6704V7.77043H0V13.6704H2ZM2 7.77043C2 5.62204 3.74161 3.88043 5.89 3.88043V1.88043C2.63704 1.88043 0 4.51747 0 7.77043H2ZM1 8.87043H19.22V6.87043H1V8.87043ZM5.38 1.44043V4.21043H7.38V1.44043H5.38ZM12.84 1.44043V4.21043H14.84V1.44043H12.84Z" 
      />
    </svg>
  );
};

export default CalendarSVG;
